<app-two-choices-control
  [title]="'P00061.installation.horloge' | translate"
  [firstLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.day'
      | translate
  "
  [firstValue]="0"
  [secondLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.week'
      | translate
  "
  [secondValue]="1"
  [value]="actionStack!.getValue('ppPTypeHorloge')"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACPOLY_Parametrage1,
      'ppPTypeHorloge',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-two-choices-control>

@if (this.actionStack!.getValue('ppPTypeHorloge') === 0) {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingsClockScreen()"
  >
  </app-larged-link>
} @else {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingClockWeekScreen()"
  >
  </app-larged-link>
}

<app-label-description
  [description]="'P00061.installation.horloge.description' | translate"
></app-label-description>

<app-label-configuration
  [title]="
    'P00062.installation.parampac.modeFonctionnementTemperature.title'
      | translate
  "
  [titleListe]="
    'P00062.installation.parampac.modeFonctionnementTemperature.value'
      | translate
  "
  [description]="
    'P00062.installation.parampac.modeFonctionnementTemperature.description'
      | translate
  "
  [value]="actionStack!.getValue('ppPModeFonctionnementTemperature')"
  [liste]="P00062ModeFonctionnementTemperature"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACPOLY_Parametrage1,
      'ppPModeFonctionnementTemperature',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-configuration
  [title]="
    'P00062.installation.parampac.modeFonctionnementRegulation.title'
      | translate
  "
  [titleListe]="
    'P00062.installation.parampac.modeFonctionnementRegulation.value'
      | translate
  "
  [information]="openEnSavoirPlus"
  [description]="
    'P00062.installation.parampac.modeFonctionnementRegulation.description'
      | translate
  "
  [value]="actionStack!.getValue('ppPModeFonctionnementRegulation')"
  [liste]="P00062ModeFonctionnementRegulation"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACPOLY_Parametrage1,
      'ppPModeFonctionnementRegulation',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-switch-configuration
  [title]="
    'P00061.installation.paraminstallation.comportementFiltration.title'
      | translate
  "
  [nameCustom]="
    'P00061.installation.paraminstallation.comportementFiltration.value'
      | translate
  "
  [value]="actionStack!.getValue('ppIActivationFonctionPriorite') !== 0"
  [description]="
    'P00061.installation.paraminstallation.comportementFiltration.description'
      | translate
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACPOLY_Installation,
      'ppIActivationFonctionPriorite',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

<app-switch-configuration
  [title]="
    'P00061.installation.paraminstallation.autoMaintienFiltration.title'
      | translate
  "
  [nameCustom]="
    'P00061.installation.paraminstallation.autoMaintienFiltration.value'
      | translate
  "
  [value]="actionStack!.getValue('ppIActivationFonctionAutoMaintien') !== 0"
  [description]="
    'P00061.installation.paraminstallation.autoMaintienFiltration.description'
      | translate
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACPOLY_Installation,
      'ppIActivationFonctionAutoMaintien',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>
